export default __webpack_public_path__ + "static/media/slider_2.d6994840.jpg";